import styledError from '../utils/error';
import { setToString } from '../utils/setToString';
import { mainStylis } from './StyleSheetManager';
var Keyframes = /** @class */ (function () {
    function Keyframes(name, rules) {
        var _this = this;
        this.inject = function (styleSheet, stylisInstance) {
            if (stylisInstance === void 0) { stylisInstance = mainStylis; }
            var resolvedName = _this.name + stylisInstance.hash;
            if (!styleSheet.hasNameForId(_this.id, resolvedName)) {
                styleSheet.insertRules(_this.id, resolvedName, stylisInstance(_this.rules, resolvedName, '@keyframes'));
            }
        };
        this.name = name;
        this.id = "sc-keyframes-".concat(name);
        this.rules = rules;
        setToString(this, function () {
            throw styledError(12, String(_this.name));
        });
    }
    Keyframes.prototype.getName = function (stylisInstance) {
        if (stylisInstance === void 0) { stylisInstance = mainStylis; }
        return this.name + stylisInstance.hash;
    };
    return Keyframes;
}());
export default Keyframes;
//# sourceMappingURL=Keyframes.js.map